import React, {useState, useEffect} from "react";
import { Alert } from "react-bootstrap";
import Fade from 'react-bootstrap/Fade';
import Collapse from 'react-bootstrap/Collapse';

export default ({ messages }) => {
  if (!messages) return null;

  return (
    <React.Fragment>
      {messages.map((message, idx) => {
        const [show, setShow] = useState(true);
        
        const content = message.content?.error ? (
          <React.Fragment>
            {message.content.error}<br />
            {Object.keys(message.content.errors).map(key => (
              <React.Fragment key={key}>{key} {message.content.errors[key]}</React.Fragment>
            ))}
          </React.Fragment>
        ) : message.content;

        useEffect(() => {
          setTimeout(() => {
            setShow(false);
          }, 5000);
        }, []);

        return (
          <Collapse in={show} key={idx}>
            <div> 
              <Alert
                variant={message.type === "error" ? "danger" : message.type}
                className="fade show"
                style={{
                  transition: "opacity 0.5s ease-in-out",
                }}
                >
                {content}
              </Alert>
            </div>
            
          </Collapse>
        );
      })}
    </React.Fragment>
  );
};
